import { concatClassnames } from "shared/utils/concatClassnames";

interface TextProps {
  children: any;
  bold?: boolean;
  className?: string;
  etc?: any;
}
const Text = ({ children, bold = false, className, ...etc }: TextProps) => {
  return (
    <p className={concatClassnames(bold && "gg-font-bold", className)} {...etc}>
      {children}
    </p>
  );
};
export default Text;
